import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=58503a43&scoped=true&"
import script from "./ModifyPassword.vue?vue&type=script&lang=js&"
export * from "./ModifyPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=58503a43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58503a43",
  null
  
)

export default component.exports